import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetDataService {
  layoutObject: any;

  constructor(private http: HttpClient) { }

  getData(serviceEndpointURL: string, dataEndPointURL: string) {
    //return this.http.get('./assets/api/createPage.json');
    //return this.http.get('./assets/api/screenjson.json');

    let body = {
      dataEndPointURL
    }

    returnÂ this.http.post(serviceEndpointURL, body)
  }

  getHeaderData() {
    return this.http.get('./assets/api/headerjson.json');
  }

  getFooterData() {
    return this.http.get('./assets/api/footer.json');
  }

  getSectionData(sectionName: string) {
    return this.http.get('./assets/api/' + sectionName + '.json');
  }

  getComponentDetails(serviceEndpointURL: string, dataEndPointURL: string) {
    let body = {
      dataEndPointURL
    }

    return this.http.post(serviceEndpointURL, body)
  }

  generateScreenResponse(screendata: any) {
    console.log(screendata);
  }

  updateLayoutObject(layoutObject: any) {
    this.layoutObject = layoutObject;
    return this.layoutObject;
  }
}
